<template>
  <router-view :key="routeId"></router-view>
</template>

<script>
  import store from '@/store/store'
  export default {
    data () {
      return {
        routeId: 0
      }
    },
    watch: {
      '$route.params.id' (newval, oldval) {
        this.routeId = newval || 0
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        await Promise.all([
          store.dispatch('resetJeMeta'),
          store.dispatch('clearJeState', true),
          store.dispatch('clearFilters')
        ])
      } catch (e) {
        console.log(e)
      }
      next()
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await Promise.all([
          store.dispatch('resetJeMeta'),
          store.dispatch('clearJeState', true),
          store.dispatch('clearFilters')
        ])
      } catch (e) {
        console.log(e)
      }
      next()
    }
  }
</script>
